import { render, staticRenderFns } from "./SubscriptionStatusChip.vue?vue&type=template&id=216dcc45&scoped=true&"
import script from "./SubscriptionStatusChip.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216dcc45",
  null
  
)

export default component.exports